import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import supportService from "../../services/api/service/supportService";

interface SalesManagerContactProps {
  name?: string;
  mobile?: string;
  email?: string;
  partnerName?: string;
  trackingId?: string;
  onCallbackResult?: (result: {
    message: string;
    severity: "error" | "success";
  }) => void;
}

const SalesManagerContact: React.FC<SalesManagerContactProps> = ({
  name = "-",
  mobile = "-",
  email = "-",
  partnerName = "-",
  trackingId = "-",
  onCallbackResult,
}) => {
  const [open, setOpen] = useState(false);

  const requestCallback = async () => {
    try {
      const response = await supportService.requestSalesManagerCallback({
        trackingId,
      });
      setOpen(false);
      onCallbackResult?.({
        message: response?.data?.message || "Callback requested successfully.",
        severity: "success",
      });
    } catch (error) {
      onCallbackResult?.({
        message: "Unable to request sales manager callback.",
        severity: "error",
      });
    }
  };


  return (
    <>
      <Box
        sx={{
          display: { xs: "flex", sm: "none" },
          flexDirection: "column",
          gap: 1,
          border: "1px solid #e5e5ea",
          borderRadius: "16px",
          p: 1.5,
          mb: 2,
          mt: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 34,
              height: 34,
              borderRadius: "8px",
              backgroundColor: "#dff8f8",
              display: "grid",
              placeItems: "center",
            }}
          >
            <PersonOutlineIcon sx={{ color: "#00b3b5", fontSize: 21 }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: 12, color: "#777487" }}>
              Your sales manager
            </Typography>
            <Typography
              sx={{ fontSize: 14, fontWeight: 700, color: "#252333" }}
            >
              {name || "-"}
            </Typography>
          </Box>
          <Button
            variant="outlined"
            onClick={() => setOpen(true)}
            sx={{
              minWidth: 82,
              height: 34,
              borderRadius: "5px",
              px: 1,
              color: "#00aeb0",
              borderColor: "#00aeb0",
              textTransform: "none",
              fontWeight: 700,
              fontSize: 12,
            }}
          >
            Contact
          </Button>
        </Box>
        {/* <Box>
          <Typography sx={{ fontSize: 12, color: "#777487" }}>
            Partner
          </Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#252333" }}>
            {partnerName || "-"}
          </Typography>
        </Box> */}
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{ sx: { borderRadius: "16px" } }}
      >
        <DialogContent sx={{ p: { xs: "26px 13px 16px", sm: 3 } }}>
          <Box
            sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 2 }}
          >
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: "10px",
                backgroundColor: "#dff8f8",
                display: "grid",
                placeItems: "center",
              }}
            >
              <PersonOutlineIcon sx={{ color: "#00b3b5" }} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontWeight: 700, fontSize: 16 }}>
                {name || "-"}
              </Typography>
              <Typography sx={{ color: "#777487", fontSize: 13 }}>
                Your sales manager
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box
            sx={{
              p: 1.25,
              mb: 1,
              backgroundColor: "#80839029",
              borderRadius: "8px",
              display: "flex",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Typography sx={{ color: "#808390", fontSize: 13 }}>
              Contact Number
            </Typography>
            <Typography
              sx={{ color: "##1F2233", fontWeight: 700, fontSize: 13 }}
            >
              {mobile || "-"}
            </Typography>
          </Box>
          <Box
            sx={{
              p: 1.25,
              mb: 1,
              backgroundColor: "#80839029",
              borderRadius: "8px",
              display: "flex",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Typography sx={{ color: "#808390", fontSize: 13 }}>
              Email
            </Typography>
            <Typography
              sx={{
                color: "##1F2233",
                fontWeight: 700,
                fontSize: 13,
                wordBreak: "break-word",
                textAlign: "right",
              }}
            >
              {email || "-"}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <Button
              variant="outlined"
              fullWidth
              startIcon={<PhoneOutlinedIcon />}
              onClick={requestCallback}
              sx={{
                height: 38,
                borderRadius: "5px",
                color: "#00aeb0",
                borderColor: "#00aeb0",
                textTransform: "none",
                fontWeight: 700,
              }}
            >
              Request for Call Back
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={() => setOpen(false)}
              sx={{
                height: 40,
                borderRadius: "5px",
                backgroundColor: "#00b3b5",
                textTransform: "none",
                fontWeight: 700,
                "&:hover": { backgroundColor: "#009b9d" },
              }}
            >
              Close
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SalesManagerContact;
